import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect } from 'react';

import { useNavigate } from '@core/hooks/navigate.hook';

import { setupInterceptors } from 'config/api';

import { RootRoutes } from './routes';
import { useAuthStore } from '@modules/auth/store';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.reset);
  useEffect(() => {
    setupInterceptors(navigate, logout);
  }, [navigate]);
  return <RootRoutes />;
}

export default App;
